// Actions
export const TEMPLATE_ACTIONS = {
  getAllTemplate: () => "GET_ALL_TEMPLATE",
  getTemplateByiD: () => "GET_TEMPLATE_BY_ID",
  deleteTemplate: () => "DELETE_TEMPLATE",
  saveUpdateTemplate: () => "SAVE_UPDATE_TEMPLATE",
  setVariableTemplate: () => "SET_VARIABLE_TEMPLATE",
  setTempVariableTemplate: () => "SET_TEMP_VARIABLE_TEMPLATE",
};
